export default __webpack_public_path__ + "static/media/modalBuddies@3x.b6759a94.png";